if (!customElements.get('watches-banner')) {
  customElements.define('watches-banner', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('click', event => {
        const link = event.target.closest('a.wb__button');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        const url = new URL(link.href, window.location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
        let id;
        try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        // Move keyboard focus without jumping before the smooth scroll starts.
        if (!target.hasAttribute('tabindex') && !target.matches('a[href],button,input,select,textarea')) {
          target.setAttribute('tabindex', '-1');
          target.addEventListener('blur', () => target.removeAttribute('tabindex'), {once:true});
        }
        target.focus({preventScroll:true});
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth', block:'start'});
        if (location.hash !== url.hash) history.pushState(null, '', url.hash);
      }, {signal});
      const image = this.querySelector('.wb__image');
      const photo = this.querySelector('.wb__photo');
      this.pivot = () => {
        const mobile = matchMedia('(max-width:900px)').matches;
        const width = photo.clientWidth, height = photo.clientHeight;
        if (!image || !image.getClientRects().length) {
          this.style.setProperty('--wb-x', '50%');
          this.style.setProperty('--wb-y', '50%');
          return;
        }
        if (getComputedStyle(image).objectFit === 'fill') {
          this.style.setProperty('--wb-x', `${width / 2 + image.clientWidth * (.486 - .5)}px`);
          this.style.setProperty('--wb-y', `${height - image.clientHeight + image.clientHeight * .646}px`);
          return;
        }
        const scale = Math.max(width / (image.naturalWidth || 2400), height / (image.naturalHeight || 1033));
        const iw = (image.naturalWidth || 2400) * scale, ih = (image.naturalHeight || 1033) * scale;
        this.style.setProperty('--wb-x', `${(width - iw) * (mobile ? .5 : .78) + iw * (mobile ? .486 : .675)}px`);
        this.style.setProperty('--wb-y', `${(height - ih) * .5 + ih * (mobile ? .646 : .527)}px`);
      };
      const start = () => {
        if (!this.isConnected || this.started) return;
        this.started = true;
        this.pivot();
        if (this.dataset.animation !== 'true' || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
        this.style.setProperty('--wb-angle', '0deg');
        this.classList.add('is-animated');
        this.frame = requestAnimationFrame(() => {
          this.frame = requestAnimationFrame(() => {
            this.classList.add('is-in', 'is-sweeping');
            // Drive the mask and hand together without depending on @property support.
            // Match the reference cubic-bezier(.55,.05,.25,1) over 1.9 seconds.
            const bezier = (t, a, b) => 3 * (1 - t) ** 2 * t * a + 3 * (1 - t) * t ** 2 * b + t ** 3;
            let began;
            const sweep = (now) => {
              began ??= now;
              const progress = Math.min((now - began) / 1900, 1);
              let low = 0, high = 1;
              for (let i = 0; i < 16; i++) {
                const mid = (low + high) / 2;
                if (bezier(mid, .55, .25) < progress) low = mid;
                else high = mid;
              }
              const angle = progress === 1 ? 360.5 : 360.5 * bezier((low + high) / 2, .05, 1);
              this.style.setProperty('--wb-angle', `${angle}deg`);
              if (progress < 1) this.frame = requestAnimationFrame(sweep);
              else this.classList.remove('is-sweeping');
            };
            this.frame = requestAnimationFrame(sweep);
          });
        });
      };
      image?.addEventListener('load', () => { this.pivot(); start(); }, {signal});
      image?.addEventListener('error', start, {signal});
      if (!image || image.complete) start();
      this.fallback = setTimeout(start, 1200);
      this.observer = new ResizeObserver(this.pivot);
      this.observer.observe(photo);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.timer);
      clearTimeout(this.fallback);
      cancelAnimationFrame(this.frame);
      this.style.removeProperty('--wb-angle');
      this.started = false;
      this.classList.remove('is-animated', 'is-in', 'is-sweeping');
    }
  });
}
